import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { utilsApps } from 'src/app/helpers/utils-app';

@Component({
  selector: 'emi-historial-cae-filter',
  standalone: true,
  imports: [TranslateModule, MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    ReactiveFormsModule],
  templateUrl: './historial-cae-filter.component.html'
})
export class HistorialCaeFilterComponent implements OnInit {
  @Output() dataFilter = new EventEmitter<any>();
  public fmFilters: any;
  private _util = new utilsApps();
  constructor(private translateService: TranslateService, private readonly fb: FormBuilder) { }

  ngOnInit(): void {
    this.createForm();
  }

  get f() {
    return this.fmFilters.controls;
  }

  private createForm() {
    this.fmFilters = this.fb.group({
      txtDateInit: [this._util.fnAddDays(-30), [Validators.required]],
      txtDateEnd: [new Date(), [Validators.required]],
    });
  }

  public searchInfo() {
    this.dataFilter.emit(this.fmFilters.value);
  }

  public deleteInfo() {

  }

}
